import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'react-material-symbols/rounded';
import store from './store/store';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';
import { initGA } from './analytics';

// Initialize Google Analytics
initGA();

const container = document.getElementById('root');
const root = createRoot(container);
var basename = process.env.REACT_APP_BASE_PATH;
if (process.env.NODE_ENV === 'production') 
{
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}
const PageVerification = lazy(() => import("page/Account/Verification"));
const PageResetPassword = lazy(() => import("page/Account/ResetPassword"));
const PageWorld = lazy(() => import("page/World"));
const PageWelcome = lazy(() => import("page/Welcome"));
const PageLogin = lazy(() => import("page/Login"));
const PageRegisterIframe = lazy(() => import("page/RegisterIframe"));

root.render(
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      <Suspense fallback={<div className='page-loader'/>}>
        <Routes>
          <Route path='/' element={<PageWelcome />} />
          <Route path='/world' element={<PageWorld />} />
          <Route path='/login' element={<PageLogin />} />
          <Route path='/register-iframe' element={<PageRegisterIframe />} />
          <Route path='/verification/:token' element={<PageVerification />} />
          <Route path='/reset-password/:token' element={<PageResetPassword />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
